import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pricing from "@/components/Pricing";
import WhyChoose from "@/components/WhyChoose";
import Availability from "@/components/Availability";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t1 = setTimeout(() => scrollToId(hash), 350);
      const t2 = setTimeout(() => scrollToId(hash), 950);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
  }, [hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Pricing />
      <WhyChoose />
      <Availability />
    </main>
  );
}